var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var lib_geometry = require('lib-geometry');
var FootprintGeneratorAddHelper = cio_datamodel.FootprintGeneratorAddHelper;
var MetaDataProperties = require("cio-config").MetaProperties;
var Model3dUploadSM = require("../modelUploader/modelUploadStateMachine.js");
var IpcPackageParamHelper = cio_datamodel.IpcPackageParamHelper;
var IpcNameHelper = cio_datamodel.IpcNameHelper;
var IpcDescriptionHelper = cio_datamodel.IpcDescriptionHelper;
var MetaDataUpdateHelper = cio_datamodel.MetaDataUpdateHelper;
var FootprintSettingsStateMachine = require("../../../shared/settings/footprintSettingsStateMachine.js");

if(typeof window !== 'undefined' )
    var ui_extensions = require("ui-extensions");

var PackageGeneratorStateMachine = function (root, model, modelUploadSM, versionSM, events, configuration) {
    var self = this;

    this.root = root;
    this.model = model;
    this.modelUploadSM = modelUploadSM;
    this.versionSM = versionSM;
    this.configuration = configuration;
    this.loadingMessageKey = "Package";
    this.versionCreationLoadingMessage = "Creating new version...";

    ui_extensions.InspectorStateMachine.call(self, root, model, events);

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.GENERATOR_SELECTED;
        },

        function(cEvent){
            var packageTypeItem = cEvent.data('packageTypeItem');
            var existingIpcData = self.root.data.ipcParametricData();

            //use existing IPC parametric data if it exists else create new IPC parametric data and add to persistent data member
            if(existingIpcData) {
                //if selected generator is different than existing generator use selected IPC data
                if(packageTypeItem.dataType !== existingIpcData.constructor.name) {
                    self.createAndAddIPCParametricDataToPersistentData(packageTypeItem.dataType);
                }

                if(self.model.masterModel && self.model.masterModel.wizardMode()) {
                    //create IM with 3D model and 2D footprint related fields
                    self.model.createInteractionForParametricData(self.root.data.ipcParametricData(), !self.model.only3dModelGenerator);
                } else if(self.model.masterModel && !self.model.masterModel.wizardMode()) {
                    //create IM only with 3D model related fields
                    self.model.createInteractionForParametricData(self.root.data.ipcParametricData(), false);
                }
            } else {
                self.createAndAddIPCParametricDataToPersistentData(packageTypeItem.dataType);
            }

            self.model.showPackageSearchBox(false);
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.GENERATOR_BACK_BUTTON_PRESSED;
        },
        function(cEvent){
            self.model.data.ipcParametricData(null);
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.GENERATE_PACKAGE;
        },
        function(cEvent){
            var minMaxFails = self.model.selectedIM().ipcGeneratorIM.data.getMinMaxFailures();

            if(minMaxFails.length == 0){
                //in non-wizard mode generate 3D model only
                if(self.model.masterModel && !self.model.masterModel.wizardMode()) {
                    self.model.generate3dModel();
                } else {
                    //warn user for overwriting persistent data
                    if(self.root.data.footprintInstances.size() > 0) {
                        self.model.showPackageOverwritingWarningPopup(true);
                    } else {
                        self.model.generatePackage();
                    }
                }
            } 
            self.triggerHandlerForInputWarnings(minMaxFails);
            
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.TOGGLE_PACKAGE_SIDEBAR;
        },
        function(cEvent){
             self.model.showGenerator(!self.model.showGenerator());
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.FINISH_PACKAGE;
        },
        function(cEvent){
            // If the finish button isn't visible, this event shouldn't do anything.
            // This is here because we call this event from the Ok button in EAGLE/Qt,
            // which is enabled even when it's not possible to finish the package.
            if(!self.model.showFinishButton()) return;

            //if user clicks on create version button and then clicks finish button on model generator reset version info
            self.resetVersionInfo();
            self.finishPackage();
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.VIEW_IPC_PARAMS_READ_ONLY;
        },

        function(cEvent){
            self.model.showIPCParametersInReadOnlyMode(!self.model.showIPCParametersInReadOnlyMode());
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.START_FORK_PACKAGE_FROM_IPC_PARAMS;
        },

        function(cEvent){
            self.model.forkMode = self.model.FORK_MODE_CONSTANT.MODE_1;
            self.startForkPackageFromIPCParams();
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.START_FORK_PUBLIC_PACKAGE;
        },

        function(cEvent){
            self.model.forkMode = self.model.FORK_MODE_CONSTANT.MODE_2;
            self.startForkPublicPackage();
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.HUB_SELECTED_AND_START_FORK_PUBLIC_PACKAGE;
        },

        function(cEvent){
            //fork current 3d package which is not owned by user and create an editable copy of current package
            self.forkCurrentPackage(cEvent.data("selectedTargetHub"));
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.HUB_SELECTED_AND_START_FORK_PACKAGE_FROM_IPC_PARAMS;
        },

        function(cEvent){
            //fork current 3d package starting from IPC params
            self.forkCurrentPackageStartingFromExistingIPCData(cEvent.data("selectedTargetHub"));
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.PACKAGE_SEARCH_BUTTON_CLICKED;
        },
        function(cEvent){
            self.model.showPackageSearchBox(true);
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.PACKAGE_SEARCH_CLOSE_BUTTON_CLICKED;
        },
        function(cEvent){
            self.model.showPackageSearchBox(false);
        }
    );

    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.PACKAGE_SEARCH_BOX_TEXT_ENTERED;
        },
        function(cEvent){
            self.model.packageGeneratorSearchName(cEvent.data('value'));
        }
    );
};

lib_core.inherit(PackageGeneratorStateMachine, ui_extensions.InspectorStateMachine);
lib_core.mixin(PackageGeneratorStateMachine, FootprintSettingsStateMachine.prototype);
module.exports = PackageGeneratorStateMachine;

PackageGeneratorStateMachine.prototype.handleHideWarningPackageOverwriting = function() {
    this.model.showPackageOverwritingWarningPopup(false);
    this.model.generatePackage();
}

PackageGeneratorStateMachine.prototype.handleOverwritePackage = function() {
    this.root.rec();
    this.root.data.footprintInstances.removeAll();
    this.root.stopRec();

            //hide popup
    this.model.showPackageOverwritingWarningPopup(false);
}

PackageGeneratorStateMachine.prototype.handleOverridePackageSettings = function(cEvent) {
    var isOverride = cEvent.data('isChecked');

    if(isOverride) {
        this.model.overridePackageSettings(true);
    } else {
        this.model.overridePackageSettings(false);
    }
}

PackageGeneratorStateMachine.prototype.handleFinishVersionCreation = function() {
    if(this.root.data.ipcParametricData()) {
        //save dummy 3d package data including footprints and 3d model if exists
        var dummyFootprintInstances = this.model.dummyPackageData.footprintInstances;

        if(dummyFootprintInstances.size() > 0) {
            this.saveDummy3dPackageAndCreateVersion(dummyFootprintInstances);
        } else if(this.model.dummyPackageData.model3d() instanceof cio_datamodel.Model3dDummyData && !this.model.dummyPackageData.isIPCDataAnd3DModelOutOfSync()) {
            this.saveDummy3dModelAndCreateVersion();
        } else {
            this.superCreateNewVersion();
        }
    } else {
        this.superCreateNewVersion();
    }
}

PackageGeneratorStateMachine.prototype.handlePrecheck = function(cEvent) {
    this.versionDescription = cEvent.data('description');

    //if 3d model is generated automatically and IPC data is dirty show warning for updating the preview
    //if 3d model is generated automatically and IPC data is not dirty show warning for finishing the package
    //if 3d model is uploaded manually, update preview is clicked and IPC data and 3d model are in sync in dummy package data show warning for finishing the package
    //create version directly in other cases
    if(!this.root.data.is3dModelUploadedManually()) {
        if(this.model.isParametricDataDirty()) {
            this.model.showWarningPopupForUnfinishedPackageUpdatePreview(true);
        } else if(this.model.dummyPackageData.footprintInstances.size() > 0
            || (this.model.dummyPackageData.model3d() instanceof cio_datamodel.Model3dDummyData && !this.model.dummyPackageData.isIPCDataAnd3DModelOutOfSync())) {
            this.model.showWarningPopupForFinishingGeneration(true);
        } else {
            this.superCreateNewVersion();
        }
    } else if(this.model.dummyPackageData.model3d() instanceof cio_datamodel.Model3dDummyData && !this.model.dummyPackageData.isIPCDataAnd3DModelOutOfSync()) {
        this.model.showWarningPopupForFinishingGeneration(true);
    } else {
        this.superCreateNewVersion();
    }
}

PackageGeneratorStateMachine.prototype.loadHubs = function() {
    var self = this;
    self.showLoadingScreen("Loading Managed Folders...");

    return self.model.dataLoader.dataManager.getHubs(true)
    .then(function(hubs) {
        hubs = hubs["hubs"].map(function(hub) {
            return {
                value: hub["id"],
                name: hub["name"]
            }
        });

        self.hideLoadingScreen();
        return hubs;
    })
    .catch(function(e) {
        logError("PackageGeneratorStateMachine", new Error("Loading Managed Folders failed."), logError.criticality.MAJOR, e.message);
        self.hideLoadingScreen();
    });
};

PackageGeneratorStateMachine.prototype.startForkPublicPackage = function() {
    var self = this;

    return self.loadHubs()
    .then(function(hubs) {

        let writeAccessToHub = false;
        if(self.configuration.targetHub){
          let targetHub = parseInt(self.configuration.targetHub);
          if(parseInt(self.configuration.targetHub) > 0){
            for(var i = 0; i < hubs.length; i++){
              if(targetHub == hubs[i].value){
                writeAccessToHub = true;
              }
            }
          }
        }

        if(hubs.length == 1) {
            return self.forkCurrentPackage(hubs[0].value);
        } else if(writeAccessToHub){
            return self.forkCurrentPackage(self.configuration.targetHub);
        } else {
            self.model.hubsList(hubs);
        }
    });
};

PackageGeneratorStateMachine.prototype.startForkPackageFromIPCParams = function() {
    var self = this;

    //if user is forking a user owned package fork the package in the same hub
    if(self.model.data.root.asset.hasUserWritePermissions()) {
        return self.forkCurrentPackageStartingFromExistingIPCData(self.model.data.root.asset.hub);
    }

    return self.loadHubs()
    .then(function(hubs) {
        if(hubs.length == 1) {
            return self.forkCurrentPackageStartingFromExistingIPCData(hubs[0].value);
        } else {
            self.model.hubsList(hubs);
        }
    });
};

PackageGeneratorStateMachine.prototype.getANewForkedPackageResource = function(targetHubId, isUnnamed) {
    var self = this;
    var thisAsset = (self.versionSM && self.versionSM.model.asset()) || self.root.asset;
    var type = thisAsset.type;
    var thisAssetId = thisAsset.id;
    var thisAssetName = thisAsset.name;
    var thisAssetURN = "urn:adsk:eagle:package:" + thisAssetId;
    var thisAssetLastVersion = thisAsset.getLastVersion().version;

    var dataManager = self.model.dataLoader.dataManager;
    var resourceInfo = {
        "name": (isUnnamed ? "New Package" : thisAssetName),
        "summary": "Forked from " + thisAssetName + " (" + thisAssetURN + ")",
        "description": "",
        "forked_from": {
            "id": thisAssetId,
            "version": thisAssetLastVersion,
        },
        "hub": targetHubId
    };

    return dataManager.createResource(resourceInfo, type)
    .then(function(asset) {
        return {
            id: asset.id,
            type: type,
            forkedFrom: {
                id: thisAssetId,
                version: thisAssetLastVersion
            }
        };
    });
};

PackageGeneratorStateMachine.prototype.forkCurrentPackageStartingFromExistingIPCData = function(targetHub) {
    var self = this;
    var forkedAssetId = null;
    var forkedAssetType = null;
    var dataManager = self.model.dataLoader.dataManager;

    self.showLoadingScreen("Forking current package. Wait a moment.");

    return self.getANewForkedPackageResource(targetHub, true)
    .then(function(forkedPackageInfo) {
        forkedAssetId = forkedPackageInfo.id;
        forkedAssetType = forkedPackageInfo.type;

        // create forked Data
        var nonShareableDataRoot = new lib_core.NonShareableDataRoot();
        var newPackageData = new cio_datamodel.PackageData(true);
        nonShareableDataRoot.attachData(newPackageData);
        var forkData = nonShareableDataRoot.jsonify();
        nonShareableDataRoot.attachData(self.root.data.ipcParametricData());

        forkData["ipcParametricData"] = nonShareableDataRoot.jsonify();

        var collabDoc = {}
        collabDoc['header'] = {
            "assetId": forkedAssetId,
            "assetType": self.root.header["assetType"],
            "datamodel_version": self.root.header["datamodel_version"],
        }
        collabDoc['body'] = forkData;

        return dataManager.createResourceDraft(forkedAssetType, forkedAssetId, collabDoc);
    })
    .then(function() {
        console.log("New package with id " + forkedAssetId + " is created.");
        self.hideLoadingScreen();
        self.openForkedPackage(forkedAssetId, forkedAssetType);
    })
    .catch(function(e) {
        logError("PackageGeneratorStateMachine", new Error("Forking current package failed."), logError.criticality.MAJOR, e.message);
        self.hideLoadingScreen();
    });
};

//Improvement: set retry limit and cancels if its not completed within that time
PackageGeneratorStateMachine.prototype.pollUntilImportFinishes = function(assetType, assetId) {
    var self = this;
    var dataManager = self.model.dataLoader.dataManager;

    return dataManager.getImportStatus(assetType, assetId)
    .then(function(response) {
        if(response["status"] === "importing") {
            return new Promise(function(res, rej) {
                setTimeout(function() {
                    res(self.pollUntilImportFinishes(assetType, assetId));
                }, 1000);
            });
        } else if(response["status"] === "done") {
            return;
        } else if(response["status"] === "failed") {
            throw new Error(response["status_details"]);
        }
    })
    .catch(function(e) {
        throw new Error(e.message);
    });
};

PackageGeneratorStateMachine.prototype.forkCurrentPackage = function(targetHub) {
    var self = this;
    var forkedAssetId = null;
    var forkedAssetType = null;
    var forkedFromAssetInfo = null;
    var dataManager = self.model.dataLoader.dataManager;

    self.showLoadingScreen("Copying current package. Wait a moment.");

    return self.getANewForkedPackageResource(targetHub)
    .then(function(forkedPackageInfo) {
        forkedFromAssetInfo = forkedPackageInfo.forkedFrom;
        forkedAssetId = forkedPackageInfo.id;
        forkedAssetType = forkedPackageInfo.type;

        return dataManager.getEagleLibraryExport(forkedAssetType, forkedFromAssetInfo.id, forkedFromAssetInfo.version);
    })
    .then(function(lbrData) {
        var lbrString = (new XMLSerializer()).serializeToString(lbrData.documentElement);
        var lbrFile = new File([lbrString], self.root.data.metaData().name() + '.lbr');

        return dataManager.importEagleLibraryFile(forkedAssetType, forkedAssetId, lbrFile);
    })
    .then(function() {
        return self.pollUntilImportFinishes(forkedAssetType, forkedAssetId);
    })
    .then(function() {
        self.hideLoadingScreen();
        self.replaceCurrentPackageWithForkedPackage(forkedAssetId, forkedAssetType);
    })
    .catch(function(e) {
        logError("PackageGeneratorStateMachine", new Error("Copying current package failed."), logError.criticality.MAJOR, e.message);
        self.hideLoadingScreen();
    });
};

PackageGeneratorStateMachine.prototype.openForkedPackage = function(newAssetId, type) {

    if(this.configuration.customOpenFork){
      this.configuration.customOpenFork(newAssetId);
    } else {
      this.model.forkedPackageURL = this.configuration.urls[type + 'Editor'] + '?assetid=' + newAssetId;
      var win = window.open(this.model.forkedPackageURL, '_blank');

      if(win) {
          win.focus();
      } else {
          this.model.showWarningPopupForOpeningForkedPackage(true);
      }
    }
};

PackageGeneratorStateMachine.prototype.replaceCurrentPackageWithForkedPackage = function(newAssetId, type) {
  if(this.configuration.customOpenFork){
    this.configuration.customOpenFork(newAssetId);
  } else {
    location.assign(this.configuration.urls[type + 'Editor'] + '?assetid=' + newAssetId);
  }
};

PackageGeneratorStateMachine.prototype.triggerHandlerForInputWarnings = function(minMaxFails) {
    var self = this;
    var inspectorElements = this.model.selectedIM().ipcGeneratorIM.getInspectorElements();

    // manually clear warning on acceptable value 
    function triggerPassHandlersOnDataMember(datamember) {

        if(datamember.handlers.setPass){
            datamember.handlers.setPass.forEach(function(k, handler){
                handler();
            });
        }
    }
    // clear all warnings
    if(minMaxFails == null || minMaxFails.length == 0) {
        for(var i = 0; i < inspectorElements.input_elements.length; i++){
            // inspector field must have shadow
            if(!inspectorElements.input_elements[i].datamember) {
                //check child items if any
                var items = inspectorElements.input_elements[i].items;

                if(items && items.length > 0) {
                    for(var k = 0; k < items.length; k++) {
                        if(!items[k].datamember) continue;
                        triggerPassHandlersOnDataMember(items[k].datamember);
                    }
                }
            } else {
                triggerPassHandlersOnDataMember(inspectorElements.input_elements[i].datamember);
            }
        }
        return
    };

    function triggerFailHandlersOnDataMember(datamember) {
        // if shadow contains either data as a trigger
        if(datamember.triggers.indexOf(minMaxFails[j][0]) != -1 || datamember.triggers.indexOf(minMaxFails[j][1]) != -1 ){
            // manually call the setFail handlers, which will trigger the inspector to
            // display the properties as red (this is also a bit of a hack)
            if(datamember.handlers.setFail){
                datamember.handlers.setFail.forEach(function(k, handler){
                    handler();
                });
            } 
        } else {
            if(j == 0) {
                // clear warning on acceptable value 
                triggerPassHandlersOnDataMember(datamember)
            }    
        }
    }

    // loop through all failed pairs (this is the datamember)
    for(var j = 0; j < minMaxFails.length; j++){
        // find the ispector element datamember (shadow) that contains either the min or max data field
        // as a trigger.  This implies that shadow controlls its flow of data (a bit of a hack, but will work)
        for(var i = 0; i < inspectorElements.input_elements.length; i++){

            // inspector field must have shadow
            if(!inspectorElements.input_elements[i].datamember) {
                //check child items if any
                var items = inspectorElements.input_elements[i].items;

                if(items && items.length > 0) {
                    for(var k = 0; k < items.length; k++) {
                        if(!items[k].datamember) continue;
                        triggerFailHandlersOnDataMember(items[k].datamember);
                    }
                }
            } else {
                triggerFailHandlersOnDataMember(inspectorElements.input_elements[i].datamember);
            }
        }
    }
};

PackageGeneratorStateMachine.prototype.createAndAddIPCParametricDataToPersistentData = function(dataType) {
    console.assert(this.model.masterModel, "Package master model not found.");

    this.root.rec();

    //set isOnly3dModelGeneratedFromIPCParam to true if there is no IPC data and only 3d model is being generated from IPC data in non-wizard mode
    if(!this.root.data.ipcParametricData()) {
        this.root.data.isOnly3dModelGeneratedFromIPCParam(!this.model.masterModel.wizardMode());
    }

    var padGeneratorData = FootprintGeneratorAddHelper.getDefaultData(dataType, new lib_geometry.Coord(0, 0), this.root.data, this.model.only3dModelGeneratedFromIPCParam());
    padGeneratorData.initialize();

    this.root.data.ipcParametricData(padGeneratorData);
    this.root.stopRec();
};

PackageGeneratorStateMachine.prototype.finishPackage = function() {
    //if IPC parametric data is changed recently and user is trying to finish the package without generating latest 3d model warn user for updating the preview
    //else warn for finishing the package
    if(this.model.isParametricDataDirty()) {
        this.model.showWarningPopupForUnfinishedPackageUpdatePreview(true);
    } else {
        if (!this.configuration.useEditor && this.configuration.customSavePackage) {
            var ipcData = this.root.data.ipcParametricData();
            var ipcName = IpcNameHelper.getIpcName(ipcData);
            this.configuration.customSavePackage(ipcName);
            this.model.showFinishButton(false); // TODO: on doc save event from Fusion
        } else {
            this.model.showWarningPopupForFinishingGeneration(true);
        }
    }
};

PackageGeneratorStateMachine.prototype.superCreateNewVersion = function() {
    var self = this;

    return this.versionSM.createNewVersion(self.versionDescription)
    .then(function(updatedVersion) {
        self.hideLoadingScreen();

        if(self.model.masterModel) {
            self.model.masterModel.wizardMode(false); //enable normal editor mode
        }

        self.resetVersionInfo();
    })
    .catch(function(err) {
        self.hideLoadingScreen();
        self.resetVersionInfo();
        throw err;
    });
};


PackageGeneratorStateMachine.prototype.saveAndCreateVersion = function() {
    var self = this;

    return self.syncContentServer() //update search index before creating a version
    .then(function() {
        return self.superCreateNewVersion();
    });
};

PackageGeneratorStateMachine.prototype.getPromiseForFootprintAssetCreation = function(footprintData) {
    var self = this;
    var assetType = 'footprint';

    //TODO: reuse footprint instances for same package and increment version without creating new resource each time generator clicked
    return this.model.dataLoader.dataManager.createVersionedResource
    (
        {
            "name": footprintData.metaData().name(),
            "description": footprintData.metaData().description(),
            "summary": footprintData.metaData().summary(),
            "private": this.root.asset.private,
            "hub": this.root.asset.hub
        },
        assetType,
        cio_datamodel.datamodel_version,
        '1',
        this.model.versionDescription.saveGeneratedFootprint,
        footprintData
    )
    .then(function(asset) {
        return self.model.dataLoader.getDescription(assetType, asset.id, asset.version, true);
    })
    .then(function(footprintDescription) {
        return new cio_datamodel.FootprintInstanceData(footprintDescription);
    });
};

PackageGeneratorStateMachine.prototype.generateAndUpload3dModel = function(name, description, summary, ipcData) {
    var self = this;
    var packageType = IpcNameHelper.getPackageTypeFor3dModelGeneration(ipcData);
    var ipcParams = IpcPackageParamHelper.getParamsForPackage(ipcData, self.model.unit);

    return self.model.dataLoader.dataManager.generate3dModelForIPCPackageType(packageType, 'step', ipcParams, false)
    .then(function(modelJsonInfo) {
        var fileName = name + '.step';
        var blob = new Blob([modelJsonInfo['step']], {type : 'text/plain'});

        return self.modelUploadSM.consumeFile(blob, fileName, true, summary, description, true);
    })
    .then(function() {
        //this is required to prevent generating and uploading 3d model again when user changes something in colab doc and creates a new version after saving first version of package
        self.model.dummyPackageData.model3d(null);
    })
    .catch(function(err) {
        self.hideLoadingScreen();
        logError("PackageVersionsStateMachine", new Error("3D STEP model could not be generated."), logError.criticality.MAJOR, err.message, true);
        throw err;
    });
};

PackageGeneratorStateMachine.prototype.saveDummy3dPackageAndCreateVersion = function(dummyFootprintInstances) {
    var self = this;
    self.versionDescription = self.versionDescription || self.model.versionDescription.saveGeneratedPackage;

    self.showLoadingScreen(self.versionCreationLoadingMessage);

    //support to have multiple dummy footprint instances in future impl. E.g., footprint instances can be for M,N,L densities for the package.
    var promiseListForFootprintAssetCreation = dummyFootprintInstances.map(function(idx, instance) {
        return self.getPromiseForFootprintAssetCreation(instance.ancestor()); //ancestor contains footprintData
    });

    var actualFootprintInstances, footprintName, footprintDescription, footprintSummary;

    Promise.all(promiseListForFootprintAssetCreation.toArray())
    .then(function(footprintInstances) {
        //store actual footprint instances created in content server
        actualFootprintInstances = footprintInstances;

        footprintName = actualFootprintInstances[0].getTitle();
        footprintDescription = actualFootprintInstances[0].getDescription();
        footprintSummary = actualFootprintInstances[0].getSummary();

        return self.generateAndUpload3dModel(footprintName, footprintDescription, footprintSummary, self.root.data.ipcParametricData());
    }).then(function() {
        //save footprint instances
        self.root.rec();

        actualFootprintInstances.forEach(function(actualFootprintInstance, idx) {
            //update 3d model transformation relative to footprint in persistent footprint instance
            var dummyFootprintInstance = self.model.dummyPackageData.footprintInstances.get(idx);

            actualFootprintInstance.model3dPosition(dummyFootprintInstance.model3dPosition());
            actualFootprintInstance.model3dRotation(dummyFootprintInstance.model3dRotation());

            //cleanup footprint instances
            self.model.dummyPackageData.footprintInstances.remove(idx);
            dummyFootprintInstance.remove();

            self.root.data.footprintInstances.push(actualFootprintInstance);
        });

        //update metadata
        MetaDataUpdateHelper.updatePackageMetaDataFromIPCParametricData(self.root.data, footprintName, footprintDescription, footprintSummary, footprintName, true);

        self.root.stopRec();

        return self.saveAndCreateVersion();
    });
};

PackageGeneratorStateMachine.prototype.saveDummy3dModelAndCreateVersion = function() {
    var self = this;
    self.versionDescription = self.versionDescription || self.model.versionDescription.saveGenerated3dModel;

    self.showLoadingScreen(self.versionCreationLoadingMessage);

    var ipcData = self.root.data.ipcParametricData();
    var ipcName = IpcNameHelper.getIpcName(ipcData);
    var ipcDescription = '<p>' + IpcDescriptionHelper.getReadableDescriptionFromIPCData(ipcData) + '</p>';
    var ipcSummary = IpcDescriptionHelper.getShortDescriptionFromIPCData(ipcData);

    //save transformations done on dummy 3d model which is always persisted in data
    //this is needed since transformation is being reset after uploading persistent 3d model data
    self.save3dModelTransformation();

    return self.generateAndUpload3dModel(ipcName, ipcDescription, ipcSummary, ipcData)
    .then(function() {
        self.root.rec();

        MetaDataUpdateHelper.updatePackageMetaDataFromIPCParametricData(self.root.data, ipcName, ipcDescription, ipcSummary, ipcName, self.model.overridePackageSettings());
        self.restore3dModelTransformation();

        self.root.stopRec();

        return self.saveAndCreateVersion();
    });
};

PackageGeneratorStateMachine.prototype.resetVersionInfo = function() {
    this.versionDescription = null;
};

PackageGeneratorStateMachine.prototype.save3dModelTransformation = function() {
    var footprintInstance = this.root.data.footprintInstances.getOne();

    this.model.dummyModel3dPosition(footprintInstance.model3dPosition().copy());
    this.model.dummyModel3dRotation(footprintInstance.model3dRotation().copy());
};

PackageGeneratorStateMachine.prototype.restore3dModelTransformation = function() {
    var self = this;

    this.root.data.footprintInstances.forEach(function(idx, footprintInstance) {
        footprintInstance.model3dPosition(self.model.dummyModel3dPosition());
        footprintInstance.model3dRotation(self.model.dummyModel3dRotation());
    });
};

PackageGeneratorStateMachine.prototype.showLoadingScreen = function(message) {
     this.model.processMessageModel.addLoad(this.loadingMessageKey, message);
};

PackageGeneratorStateMachine.prototype.hideLoadingScreen = function() {
     this.model.processMessageModel.removeLoad(this.loadingMessageKey);
};

/*
PackageGeneratorStateMachine.prototype.updateLoadingScreenMessage = function(newMessage) {
    this.model.processMessageModel.changeDetails(this.loadingMessageKey, newMessage);
};
*/
